var _style, _rect, _path, _path2, _path3, _path4, _path5, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgFullLogo = function SvgFullLogo(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 181.2 45.8",
    style: {
      enableBackground: "new 0 0 181.2 45.8"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#28557A;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.2,
    y: 6.8,
    className: "st0",
    width: 26.6,
    height: 31.9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16.4,30.6c-1.3,0-2.4,1-2.5,2.4c-0.1,1.4,1,2.4,2.4,2.4l0,0c1.3,0,2.4-1,2.5-2.3 C18.8,31.7,17.7,30.6,16.4,30.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18.8,12.9c0-1.3-1.1-2.4-2.4-2.4S14,11.6,14,12.9s1,2.4,2.3,2.4c0,0,0,0,0.1,0C17.7,15.3,18.8,14.2,18.8,12.9z "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M24.2,14.5h-2.6c-0.5,1.8-1.9,3.2-3.7,3.7v5.2H27c0.5,0,0.9-0.3,0.9-0.8c0-0.1,0-0.1,0-0.2v-4.2 C26.1,17.7,24.7,16.3,24.2,14.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29.5,10.5c-1.3,0-2.4,1.1-2.4,2.4s1.1,2.4,2.4,2.4s2.4-1,2.4-2.3c0,0,0,0,0-0.1C31.9,11.6,30.8,10.5,29.5,10.5 z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M22.9,0C10.3,0,0,10.3,0,22.9s10.3,22.9,22.9,22.9s22.9-10.3,22.9-22.9S35.5,0.1,22.9,0z M31.1,18.3v4.2 c0,2.2-1.8,4.1-4,4.1H27h-9v1.1c2.3,0.7,3.9,2.9,3.9,5.3c0,3-2.5,5.5-5.5,5.5S10.9,36,10.9,33c0-2.4,1.6-4.6,3.9-5.3v-9.5 c-2.3-0.7-3.9-2.9-3.9-5.3c0-3,2.5-5.5,5.5-5.5c2.4,0,4.6,1.6,5.3,3.9h2.6C25,9,27.2,7.4,29.6,7.4c3,0,5.5,2.5,5.5,5.5 C35.1,15.4,33.5,17.5,31.1,18.3z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M60,33.2H49.4v-2.6H60V33.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M72.8,24.4c0,2-0.4,3.5-1.3,4.7s-2.1,1.8-3.6,1.8c-1.3,0-2.3-0.4-3.1-1.3v6h-3.4V17.9h3.1l0.1,1.2 c0.8-1,1.9-1.5,3.2-1.5c1.6,0,2.8,0.6,3.6,1.7s1.3,2.8,1.3,4.8v0.3H72.8z M69.4,24.1c0-1.2-0.2-2.1-0.6-2.7s-1-1-1.8-1 c-1.1,0-1.8,0.4-2.2,1.2v5.2c0.4,0.8,1.2,1.3,2.2,1.3C68.6,28.1,69.4,26.8,69.4,24.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M82.5,29.3c-0.8,1-2,1.5-3.5,1.5c-1.4,0-2.4-0.4-3.1-1.2s-1.1-1.9-1.1-3.4v-8.3h3.4v8.2c0,1.3,0.6,2,1.8,2 c1.1,0,1.9-0.4,2.4-1.2v-9h3.4v12.7h-3.2L82.5,29.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M91.9,30.6h-3.4v-18h3.4V30.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M98.2,30.6h-3.4v-18h3.4V30.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M108.2,21.1c-0.5-0.1-0.9-0.1-1.2-0.1c-1.3,0-2.1,0.4-2.5,1.3v8.3H101V17.9h3.2l0.1,1.5 c0.7-1.2,1.6-1.7,2.8-1.7c0.4,0,0.7,0.1,1.1,0.2V21.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M115.4,30.8c-1.9,0-3.4-0.6-4.5-1.7s-1.8-2.7-1.8-4.6v-0.3c0-1.3,0.2-2.4,0.7-3.4s1.2-1.8,2.1-2.3 s1.9-0.8,3.1-0.8c1.7,0,3.1,0.5,4.1,1.6s1.5,2.6,1.5,4.7v1.4h-8.1c0.1,0.8,0.4,1.5,1,2s1.2,0.8,2.1,0.8c1.3,0,2.3-0.5,3.1-1.4 l1.7,1.9c-0.5,0.7-1.2,1.3-2.1,1.7S116.5,30.8,115.4,30.8z M115,20.4c-0.7,0-1.2,0.2-1.6,0.7s-0.7,1.1-0.8,2h4.7v-0.3 c0-0.8-0.2-1.3-0.6-1.7C116.3,20.6,115.7,20.4,115,20.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M122,24.1c0-2,0.4-3.6,1.3-4.7s2.1-1.7,3.7-1.7c1.4,0,2.4,0.5,3.2,1.6l0.2-1.3h3v17.6H130v-6 c-0.8,0.9-1.8,1.3-3.1,1.3c-1.5,0-2.7-0.6-3.6-1.8S122,26.3,122,24.1z M125.4,24.4c0,1.2,0.2,2.1,0.6,2.8s1,1,1.8,1 c1,0,1.8-0.4,2.2-1.2v-5.2c-0.4-0.8-1.1-1.2-2.2-1.2c-0.8,0-1.4,0.3-1.8,1S125.4,23,125.4,24.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M143.7,29.3c-0.8,1-2,1.5-3.5,1.5c-1.4,0-2.4-0.4-3.1-1.2s-1.1-1.9-1.1-3.4v-8.3h3.4v8.2c0,1.3,0.6,2,1.8,2 c1.1,0,1.9-0.4,2.4-1.2v-9h3.4v12.7h-3.2L143.7,29.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M155.4,30.8c-1.9,0-3.4-0.6-4.5-1.7s-1.8-2.7-1.8-4.6v-0.3c0-1.3,0.2-2.4,0.7-3.4s1.2-1.8,2.1-2.3 s1.9-0.8,3.1-0.8c1.7,0,3.1,0.5,4.1,1.6s1.5,2.6,1.5,4.7v1.4h-8.1c0.1,0.8,0.4,1.5,1,2s1.2,0.8,2.1,0.8c1.3,0,2.3-0.5,3.1-1.4 l1.7,1.9c-0.5,0.7-1.2,1.3-2.1,1.7S156.4,30.8,155.4,30.8z M155,20.4c-0.7,0-1.2,0.2-1.6,0.7c-0.4,0.5-0.7,1.1-0.8,2h4.7v-0.3 c0-0.8-0.2-1.3-0.6-1.7C156.2,20.6,155.7,20.4,155,20.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M169.4,27.1c0-0.4-0.2-0.7-0.6-1s-1.1-0.5-2-0.6c-3-0.6-4.5-1.9-4.5-3.8c0-1.1,0.5-2.1,1.4-2.8 s2.2-1.1,3.7-1.1c1.6,0,2.9,0.4,3.9,1.1s1.4,1.7,1.4,3h-3.4c0-0.5-0.2-0.9-0.5-1.2s-0.8-0.5-1.5-0.5c-0.6,0-1,0.1-1.3,0.4 s-0.5,0.6-0.5,1s0.2,0.7,0.5,0.9s1,0.4,1.8,0.6s1.6,0.4,2.1,0.6c1.8,0.7,2.7,1.8,2.7,3.4c0,1.2-0.5,2.1-1.5,2.8s-2.3,1.1-3.8,1.1 c-1.1,0-2-0.2-2.8-0.6s-1.5-0.9-1.9-1.6s-0.7-1.4-0.7-2.1h3.2c0,0.6,0.3,1.1,0.7,1.4s1,0.5,1.7,0.5c0.6,0,1.1-0.1,1.5-0.4 S169.4,27.5,169.4,27.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M178.9,14.8v3.1h2.2v2.5h-2.2v6.3c0,0.5,0.1,0.8,0.3,1s0.5,0.3,1,0.3c0.4,0,0.7,0,1-0.1v2.6 c-0.7,0.2-1.3,0.3-2.1,0.3c-2.4,0-3.6-1.2-3.6-3.6v-6.8h-1.9v-2.5h1.9v-3.1C175.5,14.8,178.9,14.8,178.9,14.8z"
  }))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgFullLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/full-logo.c02f130c51f0eb3090b06214514ac0f1.svg";